export default __webpack_public_path__ + "static/media/bg-min.4adcb7a3.png";